import { TimebasedKpiData } from "../../app/components/dashboard/models/dashboard.models";
import { StackedBarChartDatasets } from "../components/stacked-bar-chart/stacked-bar-chart.model";

export function extractKPIS(
  data: Array<TimebasedKpiData>,
): StackedBarChartDatasets[] {
  if (!data || data.length === 0) return [];

  const propertyKeys = Object.keys(data[0]).filter(
    (key) => key !== "time_segment",
  );

  const kpis = propertyKeys.map((prop) => ({
    name: prop,
    data: data.map((item) => Number(item[prop])),
  }));

  return kpis;
}

export function extractSegment(
  data: Array<TimebasedKpiData>,
  segment: string,
): string[] {
  return data?.map((item) => item[segment] as string);
}

export function getFuelVolumeOverviewPercents(
  data: TimebasedKpiData[],
): number[] {
  if (!data?.length) return [];

  const numericKeys = Object.keys(data[0]).filter(
    (key) => typeof data[0][key as keyof (typeof data)[0]] === "number",
  );
  const totals: Record<string, number> = {};

  numericKeys.forEach((key) => {
    totals[key] = data.reduce(
      (sum: number, item: TimebasedKpiData) =>
        sum + (item[key as keyof typeof item] as number),
      0,
    );
  });

  const totalSum = Object.values(totals).reduce((sum, val) => sum + val, 0);
  const percentages = numericKeys.map((key) => (totals[key] / totalSum) * 100);

  return percentages.map((num) => parseFloat(num.toFixed(2)));
}
